import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const ProdottiAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		nome_prodotto: yup.string().required().label("Nome Prodotto"),
		descrizione: yup.string().nullable().label("Descrizione"),
		id_categoria: yup.string().required().label("Id Categoria"),
		scheda_prodotto: yup.string().nullable().label("Scheda Prodotto"),
		foto_copertina: yup.string().nullable().label("Foto Copertina"),
		visibile_in_home: yup.string().nullable().label("Visibile In Home")
	});
	
	//form default values
	const formDefaultValues = {
		nome_prodotto: '', 
		descrizione: '', 
		id_categoria: '', 
		scheda_prodotto: '', 
		foto_copertina: '', 
		visibile_in_home: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/prodotti`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="ProdottiAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Aggiungere nuova"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Nome Prodotto *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="nome_prodotto"  onChange={formik.handleChange}  value={formik.values.nome_prodotto}   label="Nome Prodotto" type="text" placeholder="accedere Nome Prodotto"        className={inputClassName(formik?.errors?.nome_prodotto)} />
                                                <ErrorMessage name="nome_prodotto" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Descrizione 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="descrizione"  onChange={formik.handleChange}  value={formik.values.descrizione}   label="Descrizione" type="text" placeholder="accedere Descrizione"        className={inputClassName(formik?.errors?.descrizione)} />
                                                <ErrorMessage name="descrizione" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Id Categoria *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/id_categoria_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="id_categoria"     optionLabel="label" optionValue="value" value={formik.values.id_categoria} onChange={formik.handleChange} options={response} label="Id Categoria"  placeholder="Seleziona un valore ..."  className={inputClassName(formik?.errors?.id_categoria)}   />
                                                    <ErrorMessage name="id_categoria" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Scheda Prodotto 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.scheda_prodotto)}>
                                                    <Uploader name="scheda_prodotto" showUploadedFiles value={formik.values.scheda_prodotto} uploadPath="fileuploader/upload/scheda_prodotto" onChange={(paths) => formik.setFieldValue('scheda_prodotto', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label="Scegli i file o trascina i file qui" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="scheda_prodotto" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Foto Copertina 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.foto_copertina)}>
                                                    <Uploader name="foto_copertina" showUploadedFiles value={formik.values.foto_copertina} uploadPath="fileuploader/upload/foto_copertina" onChange={(paths) => formik.setFieldValue('foto_copertina', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label="Scegli i file o trascina i file qui" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="foto_copertina" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Visibile In Home 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="visibile_in_home"     optionLabel="label" optionValue="value" value={formik.values.visibile_in_home} onChange={formik.handleChange} options={app.menus.inEvidenza} label="Visibile In Home"  placeholder="Seleziona un valore ..."  className={inputClassName(formik?.errors?.visibile_in_home)}   />
                                                <ErrorMessage name="visibile_in_home" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Sottoscrivi" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
ProdottiAddPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'prodotti',
	apiPath: 'prodotti/add',
	routeName: 'prodottiadd',
	submitButtonLabel: "Sottoscrivi",
	formValidationError: "Il modulo non è valido",
	formValidationMsg: "Si prega di compilare il modulo",
	msgTitle: "Crea registro",
	msgAfterSave: "Record aggiunto con successo",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ProdottiAddPage;
